import { useState } from 'react'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Type from 'components/Type'
import Paper from 'components/Paper'
import Currency from 'components/Currency'
import Button from 'components/Button'
import Icon from 'components/Icon'
import TooltipPopover from 'components/TooltipPopover'
import { getParam } from 'utils/helpers'
import { useHeaderNavigation } from 'utils/hooks'
import { useSavingsTotals } from 'utils/actions'

const SpendingPower = () => {
  const navigate = useHeaderNavigation()
  const [open, setOpen] = useState(false)
  const {
    currentSavings,
    currentPoints,
    currentCompanyPoints,
    hasPoints,
    hasCompanyPoints,
    spendingPower,
    needsWallet,
  } = useSavingsTotals()

  // if (needsWallet && !spendingPower) {
  //   return (
  //     <Box
  //       sx={{
  //         'button': {
  //           py: {
  //             xx: .5,
  //             md: 1,
  //           },
  //           px: {
  //             xx: 1,
  //           },
  //           minHeight: {
  //             xx: 40,
  //             md: 50,
  //           },
  //         },
  //       }}
  //     >
  //       <Button
  //         outlined
  //         color="secondary_b500"
  //         radius="full"
  //         font="buttonLarge"
  //         onClick={() => navigate('/onboarding/welcome')}
  //       >
  //         Create My Wallet
  //       </Button>
  //     </Box>
  //   )
  // }

  return (
    <Box>
      <TooltipPopover
        open={open}
        onOpen={() => {
          setOpen(prev => {
            if (!prev) setOpen(true)
          })
        }}
        onClose={() => {
          setOpen(prev => {
            if (prev) setOpen(false)
          })
        }}
        hover
        tooltipClassname="money"
        containerProps={{
          display: 'initial',
        }}
        tooltipContents={(
          <Stack
            p={1}
            gap={.5}
            width="200px"
          >
            <Stack
              sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
            >
              <Stack
                sx={theme => theme.internalMixins.columns({ gap: .5 })}
              >
                <Icon
                  icon="Coin"
                  width="15"
                  height="15"
                />
                <Type
                  variant="dataMicro"
                  sx={{
                    color: '#19968C',
                  }}
                >
                  Cash Savings
                </Type>
              </Stack>
              <Type
                variant="dataMicro"
                sx={{
                  color: '#19968C',
                }}
              >
                <strong><Currency amount={currentSavings} /></strong> 
              </Type>
            </Stack>
            {hasCompanyPoints && (
              <Stack
                sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
              >
                <Stack
                  sx={theme => theme.internalMixins.columns({ gap: .5 })}
                >
                  <Icon
                    icon="DondePointCoin"
                    width="15"
                    height="15"
                  />
                  <Type
                    variant="dataMicro"
                    sx={{
                      color: '#19968C',
                    }}
                  >
                    Company Points
                  </Type>
                </Stack>
                <Type
                  variant="dataMicro"
                  sx={{
                    color: '#19968C',
                  }}
                >
                  <strong><Currency amount={currentCompanyPoints} /></strong> 
                </Type>
              </Stack>
            )}
            {hasPoints && (
              <Stack
                sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
              >
                <Stack
                  sx={theme => theme.internalMixins.columns({ gap: .5 })}
                >
                  <Icon
                    icon="DondePointCoin"
                    width="15"
                    height="15"
                  />
                  <Type
                    variant="dataMicro"
                    sx={{
                      color: '#19968C',
                    }}
                  >
                    Dónde Points
                  </Type>
                </Stack>
                <Type
                  variant="dataMicro"
                  sx={{
                    color: '#19968C',
                  }}
                >
                  <strong><Currency amount={currentPoints} /></strong> 
                </Type>
              </Stack>
            )}
          </Stack>
        )}
        label={(
          <Box
            sx={{
              position: 'relative',
            }}
            onClick={() => navigate('/wallet')}
          >
            <Paper
              round="full"
              variant="none"
              width="100%"
              height={{
                xx: 40,
                md: 50,
              }}
              sx={theme => ({
                background: 'linear-gradient(272deg, #19968C 0.86%, #53CB8A 96.33%)',
                opacity: .1,
                transition: theme.transitions.create(['opacity']),
                '+ div .spending-power-text': {
                  background: 'linear-gradient(272deg, #19968C 0.86%, #53CB8A 96.33%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textFillColor: 'transparent',
                },
                '&:hover': {
                  opacity: 1,
                  '+ div .spending-power-text': {
                    WebkitTextFillColor: 'white',
                    textFillColor: 'white',
                  },
                },
              })}
            >
              <Stack
                px={1.5}
                py={.5}
                sx={{
                  opacity: 0,
                }}
              >
                <Type
                  className="spending-power-text"
                  variant="bodyLabelBold"
                >
                  <Currency
                    amount={spendingPower}
                  />
                </Type>
              </Stack>
              <div data-client-points style={{ display: 'none' }}>{getParam('current_savings')}</div>
            </Paper>
            <Stack
              px={1.5}
              py={1}
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: '100%',
                width: '100%',
                display: 'grid',
                placeContent: 'center',
                placeItems: 'center',
                pointerEvents: 'none',
              }}
            >
              <Type
                className="spending-power-text"
                variant="bodyLabelBold"
              >
                <Currency
                  amount={spendingPower}
                />
              </Type>
            </Stack>

          </Box>
        )}
      />
    </Box>
  )
}

export default SpendingPower